import { useEffect } from "react";

interface PageSEOProps {
  /** One or more JSON-LD schema objects */
  jsonld: Record<string, unknown> | Record<string, unknown>[];
  /** Page title for document.title */
  title?: string;
  /** Page meta description */
  description?: string;
  /** Canonical URL path (without domain) */
  canonicalPath?: string;
}

const SITE_URL = (import.meta as Record<string, unknown>).env && typeof (import.meta as Record<string, unknown>).env === "object"
  ? ((import.meta as Record<string, { VITE_SITE_URL?: string }>).env?.VITE_SITE_URL || "https://acbuyspreadsheet.courses")
  : "https://acbuyspreadsheet.courses";

export default function PageSEO({ jsonld, title, description, canonicalPath }: PageSEOProps) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement("meta");
        metaDesc.setAttribute("name", "description");
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute("content", description);
    }
    if (canonicalPath) {
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", `${SITE_URL}${canonicalPath}`);
    }

    // Clean up old JSON-LD scripts from this component
    const existingScripts = document.querySelectorAll('script[data-page-seo="true"]');
    existingScripts.forEach((s) => s.remove());

    // Inject new JSON-LD
    const schemas = Array.isArray(jsonld) ? jsonld : [jsonld];
    schemas.forEach((schema) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-page-seo", "true");
      script.textContent = JSON.stringify(schema, null, 2);
      document.head.appendChild(script);
    });

    return () => {
      const scripts = document.querySelectorAll('script[data-page-seo="true"]');
      scripts.forEach((s) => s.remove());
    };
  }, [jsonld, title, description, canonicalPath]);

  return null;
}